import { FilterNames } from '../../constants';
import AbstractSelectFilterHandler from '../../../shop-ui/includes/filter-state/AbstractSelectFilterHandler';
import { IFilterStateHandler, ISelectFilterOption, ISelectFilter } from '../../../shop-ui/components/search-page/interfaces';

export default class ManufacturerFilterHandler extends AbstractSelectFilterHandler implements IFilterStateHandler {
    public createQueryParams = (filter: ISelectFilter, params: object): void => {
        params[FilterNames.MAKE] = filter.options
            .filter(option => option.selected)
            .map(selectedOption => selectedOption.value);
    }

    public resetQueryParams = (params: object): void => {
        params[FilterNames.MAKE] = [];
    }

    public getSelectedOptions = (filter: ISelectFilter): ISelectFilterOption[] => filter.options
        .filter(option => option.selected)
        .sort((option, nextOption) =>
            option.label.toLowerCase().localeCompare(nextOption.label.toLowerCase()),
        );

    public updateSelectedOptions = (filter: ISelectFilter, selectedValues: string[]): void => {
        filter.options = filter.options.map((option: ISelectFilterOption) => {
            option.selected = selectedValues.includes(option.value);

            return option;
        });
    }
}
